export default __webpack_public_path__ + "static/media/DGAutoLtd-1.4407a4d5.jpg";